import { getCookie, setCookie } from 'redux/saga/helpers/cookies';

const COOKIE_NAME = 'cpUserType';

export const isValidUserType = type => ['prospect', 'lead', 'churned', 'subscribed', 'registered'].includes(type);

export const sanitizeUserType = type => (isValidUserType(type) ? type : '');

const STATUS_TO_USERTYPE = {
  cancelled: 'churned',
  active: 'subscribed',
  unsubscribed: 'registered',
};

const get = () => getCookie(COOKIE_NAME, 'prospect');

const set = userType =>
  setCookie(COOKIE_NAME, userType, {
    path: '/',
    expires: new Date(2024, 0, 1),
  });

export const getUserTypeFromProfile = profile => {
  if (profile && profile.membership) {
    return STATUS_TO_USERTYPE[profile.membership.status];
  }
};

const setFromProfile = profile => {
  const userType = getUserTypeFromProfile(profile);
  if (userType) {
    set(userType);
  }
};

export { setFromProfile };
export { get };
export { set };
export { COOKIE_NAME };
export { STATUS_TO_USERTYPE };
